import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const Package = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12 1.25195C12.4827 1.25195 12.957 1.3788 13.375 1.62012L13.374 1.62109L20.3721 5.61914L20.375 5.62012L20.5283 5.71582C20.8777 5.94942 21.1697 6.26069 21.3809 6.62598C21.6221 7.04342 21.7495 7.51688 21.75 7.99902V16.001C21.7495 16.4831 21.6221 16.9566 21.3809 17.374C21.1395 17.7915 20.7926 18.1388 20.375 18.3799L20.3721 18.3809L13.374 22.3789L13.375 22.3799C12.9804 22.6076 12.5356 22.7317 12.0811 22.7451C12.0544 22.748 12.0274 22.75 12 22.75C11.9723 22.75 11.9449 22.7481 11.918 22.7451C11.4637 22.7316 11.0193 22.6075 10.625 22.3799L3.62793 18.3809L3.625 18.3799C3.20736 18.1388 2.86048 17.7915 2.61914 17.374C2.37787 16.9566 2.25055 16.4831 2.25 16.001V7.99902L2.25586 7.81836C2.28391 7.39914 2.4081 6.99114 2.61914 6.62598C2.86048 6.20846 3.20736 5.86124 3.625 5.62012L3.62793 5.61914L10.625 1.62109C11.043 1.37977 11.5173 1.25195 12 1.25195ZM3.75 15.999L3.76074 16.1621C3.78221 16.3241 3.83569 16.4807 3.91797 16.623C4.02764 16.8128 4.18522 16.9705 4.375 17.0801L11.25 21.0088V12.4326L3.75 8.12793V15.999ZM16.8779 10.0635C16.8589 10.0746 16.8411 10.0873 16.8213 10.0967L12.75 12.4336V21.0088L19.625 17.0801C19.8148 16.9705 19.9724 16.8128 20.082 16.623C20.1915 16.4336 20.2496 16.2188 20.25 16V8.12891L16.8779 10.0635ZM4.51562 6.83789L12.001 11.1348L14.9893 9.41895L7.49902 5.13281L4.51562 6.83789ZM12 2.75195C11.7807 2.75195 11.565 2.80931 11.375 2.91895L11.3721 2.9209L9.01074 4.26953L16.4961 8.55371L19.4844 6.83887L12.6279 2.9209L12.625 2.91895C12.435 2.80931 12.2193 2.75195 12 2.75195Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}
